var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60.76 60.42",
    style: {
      enableBackground: "new 0 0 60.76 60.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-warning{fill:#F8B133;}\n\t.st1-warning{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0-warning",
    cx: 30.38,
    cy: 30.21,
    r: 29.49
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x32_9tnie.tif_00000101823066342499741220000017760719784411400864_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1-warning",
    d: "M46.65,37.55c-0.19,0.67-0.3,1.38-0.6,1.99c-1.08,2.21-2.9,3.33-5.36,3.34c-4.57,0.02-9.14,0.01-13.71,0.01 c-2.31,0-4.61,0-6.92,0c-1.85,0-3.43-0.66-4.58-2.12c-1.46-1.85-1.81-3.93-0.77-6.06c0.87-1.78,1.94-3.47,2.93-5.19 c2.55-4.42,5.11-8.84,7.66-13.26c0.93-1.61,2.27-2.63,4.11-2.99c2.09-0.41,4.56,0.55,5.68,2.35c1.2,1.94,2.32,3.93,3.46,5.91 c2.35,4.06,4.69,8.13,7.05,12.19c0.53,0.91,0.91,1.85,1.05,2.89C46.65,36.91,46.65,37.23,46.65,37.55z M30.33,40.26 c3.42,0,6.83,0.01,10.25-0.01c0.52,0,1.07-0.09,1.54-0.29c1.77-0.76,2.4-2.83,1.43-4.53c-1.06-1.85-2.13-3.7-3.2-5.55 c-2.37-4.11-4.75-8.22-7.11-12.33c-0.4-0.7-0.93-1.26-1.69-1.55c-1.53-0.58-3.09,0-3.95,1.49c-2.74,4.73-5.47,9.46-8.2,14.19 c-0.77,1.34-1.57,2.66-2.29,4.02c-0.56,1.05-0.45,2.13,0.2,3.13c0.66,1.01,1.63,1.42,2.81,1.42 C23.52,40.26,26.93,40.26,30.33,40.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1-warning",
    d: "M32.05,24.3c-0.13,2.23-0.26,4.45-0.39,6.68c-0.02,0.31,0,0.62-0.05,0.91c-0.1,0.61-0.63,1.03-1.24,1.02 c-0.6-0.01-1.12-0.41-1.19-1.02c-0.09-0.83-0.12-1.66-0.18-2.5c-0.11-1.7-0.2-3.4-0.31-5.09c-0.09-1.42,1.18-2.42,2.39-1.86 C31.87,22.81,32.1,23.49,32.05,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1-warning",
    d: "M28.74,35.7c0.01-0.9,0.76-1.65,1.66-1.64c0.92,0,1.64,0.75,1.63,1.7c-0.01,0.9-0.75,1.63-1.64,1.62 C29.47,37.38,28.73,36.62,28.74,35.7z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.eeac07bd.svg";
export { ForwardRef as ReactComponent };